import './index.css';
const isArraysEquals = (arrayA, arrayB) => arrayA.length === arrayB.length && arrayA.every((item) => arrayB.includes(item));

export { isArraysEquals };
//# sourceMappingURL=isArraysEquals.js.map
